module.exports = __webpack_public_path__ + "static/profile1-2068666ad6bc4872c1a5d156267afb3f.jpg";